import publicacion from "./publicacion"
export default {
    publicacion,
    Reducers: {
        ...publicacion.Reducers
    },

}